function getCssVar(id: string, host: HTMLElement) {
   return parseInt(getComputedStyle(host).getPropertyValue(id), 10);
}


export function getLocalCssVar(id: string, host: HTMLElement): number {
   const localVar = getCssVar(id, host);

   if(localVar === null) {
      throw new Error(`Variable '${id}' have not been found in local context`);
   }

   return localVar;
}


export function getGlobalCssVar(id: string) : number {
   const globalVar = getCssVar(id, document.documentElement) || null;
   
   if(globalVar === null) {
      throw new Error(`Variable '${id}' have not been found in global context`);
   }

   return globalVar;
}


export function getGlobalOrLocalCssVar(id: string, host: HTMLElement): number {
   let globalVar: number;
   let localVar: number;

   try {
      globalVar = getGlobalCssVar(id);
   } catch (e) {
      globalVar = null;
   }

   try {
      localVar = getLocalCssVar(id, host);
   } catch (e) {
      localVar = null;
   }

   const finish = localVar || globalVar || null;

   if(finish === null) {
      throw new Error(`Variable '${id}' have not been found neither in global or local contexts`);
   }

   return finish;
}